import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { PageContentDto } from '../../../services/dtos/page-content.dto';
import { getPageContent, toPageContentDTO } from '../../../services/page.service';
import { showAxiosMessageError } from '../../../services/error-message.service';
import MovingInBillContractUi from '../../../components/user-interfaces/moving-in/moving-in-bill-contract/moving-in-bill-contract.ui';
import { ContractFormInfosDto } from '../../../services/dtos/form/contract-form-infos.dto';
import { AxiosError } from 'axios';
import { getAddressByBill } from '../../../services/requests.service';
import { MovingInFinishDto } from '../../../services/dtos/moving-in-finish.dto';
import { useLocalStorage } from '../../../hooks/use-local-storage.hook';

/**
 * Page de rattachement de contrat
 * @constructor
 */
export default function MovingInBillContractPage() {
    //Déclaration de la navigation
    const navigate = useNavigate();
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);

    // Déclaration du loader pour l'affichage du Skeleton
    const [loading, setLoading] = useState<boolean>(true);
    // Bool pour éviter le spam du bouton Valider
    const [validate, setValidate] = useState<boolean>(false);
    //Infos j'emmenage dans le local storage
    let [movingInFinish, setMovingInFinish] = useLocalStorage('movingInFinish', '');

    /**
     * Comportement à la soumission du formulaire
     * @param e Infos du form
     */
    const handlerSubmit = (e: ContractFormInfosDto) => {
        // Désactivation du bouton Valider
        setValidate(true);
        getAddressByBill(e)
            .then(result => {
                showMessage.successAlert('Nous avons trouvé une adresse correspondant aux critères fournis');
                const data: MovingInFinishDto = {
                    address: result,
                };
                setMovingInFinish(data);
                // Retour à la page d'accueil
                navigate('/j-emmenage/etape-deux');
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                // Réactivation du bouton après le traitement
                setValidate(false);
            });
    };

    /**
     * Comportement à l'annulation du formulaire
     */
    const handlerCancel = () => {
        // Retour à la page d'accueil
        navigate('/j-emmenage');
    };

    //Création de données par défaut pour la page
    const [pageContent, setPageContent] = useState<PageContentDto>({
        content: undefined,
        title: undefined,
        image: '../../../assets/images/logo-sddea.png',
    });

    // Récupère les données du back permettant de construire la page
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        getPageContent('emmenage')
            .then(async result => {
                //On met le résultat de la request dans la variable envoyée à la page
                if (result) {
                    setPageContent(await toPageContentDTO(result));
                }
                setLoading(false);
            })
            .catch(error => {
                //Affichage du message d'erreur si la request ne récupère rien
                console.error('Erreur lors de la récupération du contenu de la page');
                showAxiosMessageError(error, showMessage);
            });
    }, [showMessage, movingInFinish]);

    // Appel de l'interface, qui contiendra le form
    return (
        <MovingInBillContractUi
            handlerSubmit={handlerSubmit}
            handlerCancel={handlerCancel}
            pageContent={pageContent}
            loading={loading}
            validate={validate}
        />
    );
}
